import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  DropdownIndicator,
  Option,
} from 'components/application/CollectionSelect';

export default function SelectFilter({
  autoFocus = false,
  id,
  label,
  name,
  onChange,
  onRemove,
  options,
  placeholder,
}) {
  const handleChange = (selected) => {
    onChange(selected.value);
  };

  return (
    <>
      <div className='tw-mb-4 tw-flex tw-items-center tw-justify-between'>
        <label className='tw-m-0 tw-font-medium'>{label}</label>
        <div
          className='tw-flex tw-h-5 tw-cursor-pointer tw-items-center tw-rounded-lg tw-border-0 tw-bg-white tw-px-2 tw-text-grey-500 hover:tw-bg-red-025 hover:tw-text-red-500'
          onClick={onRemove}
        >
          <span className='tw-text-s tw-font-medium tw-tracking-wide'>
            Remove filter
          </span>
        </div>
      </div>
      <Select
        autoFocus={autoFocus}
        className='collection-select__select-container collection-select--transparent-option'
        classNamePrefix='collection-select'
        components={{ DropdownIndicator, Option }}
        controlShouldRenderValue={false}
        id={id}
        isSearchable={false}
        name={name}
        onChange={handleChange}
        openMenuOnFocus={true}
        options={options}
        placeholder={placeholder}
        styles={{
          menu: (base) => ({ ...base, maxHeight: 244 }),
          menuList: (base) => ({ ...base, maxHeight: 242 }),
        }}
        value={null}
      />
    </>
  );
}

SelectFilter.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
